export default {
    title: 'Data Protection',
    sidebar: 'Data protection',

    description: {
        what: 'Add an extra layer of security to sensitive sections of your account, such as financial statistics.',
        how: 'Once enabled, you\'ll be asked to enter a short PIN before accessing protected areas. Sessions last 15 minutes before re-authentication is required.',
        note: 'This PIN is separate from your account password and is designed for quick access control — for example, to prevent unauthorized viewing when you step away from your computer.',
    },

    set: {
        passcode: 'PIN',
        placeholder: 'Enter a PIN (min. 4 characters)',
        confirm: 'Confirm PIN',
        confirmPlaceholder: 'Repeat your PIN',
        submit: 'Set PIN',
        success: 'PIN has been set successfully.',
    },

    change: {
        title: 'Change PIN',
        subtitle: 'Update your existing PIN.',
        currentPasscode: 'Current PIN',
        newPasscode: 'New PIN',
        confirmPasscode: 'Confirm new PIN',
        placeholders: {
            current: 'Enter your current PIN',
            new: 'Enter your new PIN (min. 4 characters)',
            confirm: 'Repeat your new PIN',
        },
        submit: 'Change PIN',
        success: 'PIN has been changed successfully.',
        incorrect: 'The current PIN is incorrect.',
    },

    remove: {
        description: 'For security, a removal link will be sent to your email address.',
        submit: 'Request removal',
        success: 'A removal link has been sent to your email.',
    },

    removal: {
        title: 'PIN Removal',
        processing: 'Removing your PIN...',
        success: 'Your PIN has been removed successfully.',
        expired: 'This removal link has expired. Please request a new one from your settings.',
        invalid: 'This removal link is invalid.',
        backToSettings: 'Back to settings',
    },

    gate: {
        title: 'This section is locked',
        subtitle: 'Enter your PIN to view this content.',
        goToSettings: 'Go to settings',
        sessionExpired: 'Your session has expired',
    },

    session: {
        protectedSection: 'Protected session',
        remaining: 'remaining',
        lockNow: 'Lock now',
    },

    modal: {
        placeholder: 'Enter your PIN',
        submit: 'Unlock',
        incorrect: 'The PIN you entered is incorrect.',
        forgot: 'Forgot PIN?',
    },

    validation: {
        minLength: 'PIN must be at least 4 characters.',
        mismatch: 'PINs do not match.',
    },

    status: {
        enabled: 'PIN protection is active',
        enabledDescription: 'Your sensitive data is currently protected. You\'ll be asked for your PIN when accessing secured sections.',
        disabled: 'PIN protection is disabled',
        disabledDescription: 'Set a PIN to protect sensitive sections of your account.',
    },
}
